import React from 'react';
import { Icon } from './Icon';

// MainPage Component - Simplified version that works with current props
const MainPage = ({
  currentUser,
  attendanceData,
  paymentData,
  newsData,
  schoolEvents,
  onTabChange,
  calculateAttendanceRate,
  getAttendanceStatus,
  formatCurrency,
  formatDate
}) => {
  // Defensive programming - ensure arrays exist before filtering
  const safeAttendanceData = Array.isArray(attendanceData) ? attendanceData : [];
  const safePaymentData = Array.isArray(paymentData) ? paymentData : [];
  const safeNewsData = Array.isArray(newsData) ? newsData : [];
  const safeSchoolEvents = Array.isArray(schoolEvents) ? schoolEvents : [];

  // Get recent attendance data
  const recentAttendance = safeAttendanceData.slice(0, 5);
  
  // Get recent payment data
  const recentPayments = safePaymentData.slice(0, 5);
  
  // Get recent news
  const recentNews = safeNewsData.slice(0, 5);
  
  // Get upcoming events
  const upcomingEvents = safeSchoolEvents.slice(0, 3);

  return (
    <div style={{maxWidth: '1200px', margin: '0 auto'}}>
      {/* Header Section */}
      <div style={{marginBottom: '32px'}}>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1f2937',
          marginBottom: '8px'
        }}>
          歡迎回來，{currentUser?.name || '用戶'}
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          今天是 {new Date().toLocaleDateString('zh-TW')}，讓我們開始今天的工作
        </p>
      </div>

      {/* Quick Stats */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#10b981',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>📊</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>考勤紀錄</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {safeAttendanceData.length}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#3b82f6',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>💰</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>繳費紀錄</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {safePaymentData.length}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#f59e0b',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>📰</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>學校宣佈</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {safeNewsData.length}
              </div>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: '#8b5cf6',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{color: 'white', fontSize: '24px'}}>🎉</span>
            </div>
            <div>
              <div style={{fontSize: '14px', color: '#6b7280', marginBottom: '4px'}}>學校活動</div>
              <div style={{fontSize: '24px', fontWeight: '700', color: '#1f2937'}}>
                {safeSchoolEvents.length}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '32px'
      }}>
        <button 
          onClick={() => onTabChange('attendance')}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📊 考勤紀錄
        </button>
        
        <button 
          onClick={() => onTabChange('payment')}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          💰 繳費紀錄
        </button>
        
        <button 
          onClick={() => onTabChange('news')}
          style={{
            backgroundColor: '#f59e0b',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📰 學校宣佈
        </button>
        
        <button 
          onClick={() => onTabChange('school-events')}
          style={{
            backgroundColor: '#8b5cf6',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          🎉 學校活動
        </button>
        
        <button 
          onClick={() => onTabChange('academic-calendar')}
          style={{
            backgroundColor: '#06b6d4',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📅 校曆表
        </button>
        
        <button 
          onClick={() => onTabChange('teacher-directory')}
          style={{
            backgroundColor: '#ec4899',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          👥 教師通訊錄
        </button>

        {/* New Information Buttons */}
        <button 
          onClick={() => onTabChange('teacher-info')}
          style={{
            backgroundColor: '#667eea',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          👨‍🏫 教師資訊
        </button>
        
        <button 
          onClick={() => onTabChange('student-info')}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          👨‍🎓 學生資訊
        </button>
        
        <button 
          onClick={() => onTabChange('class-info')}
          style={{
            backgroundColor: '#f59e0b',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          🏫 班級資訊
        </button>

        {/* Staff Button */}
        <button 
          onClick={() => onTabChange('staff')}
          style={{
            backgroundColor: '#8b5cf6',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          👷 職員
        </button>

        {/* Library Button */}
        <button 
          onClick={() => onTabChange('library')}
          style={{
            backgroundColor: '#059669',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          📚 圖書館
        </button>

              {/* Enhanced App Store Button */}
              <button
                onClick={() => onTabChange('app-store')}
                style={{
                  backgroundColor: '#8b5cf6',
                  color: 'white',
                  border: 'none',
                  padding: '16px',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                🚀 Enhanced AppStore
              </button>

              {/* AI AppStore Button */}
              <button
                onClick={() => onTabChange('app-store')}
                style={{
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '16px',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                🛍️ AI AppStore
              </button>

            {/* Developer Portal Button */}
            <button
              onClick={() => onTabChange('developer-portal')}
              style={{
                backgroundColor: '#059669',
                color: 'white',
                border: 'none',
                padding: '16px',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              👨‍💻 Developer Portal
            </button>

            {/* Admin Review System Button */}
            <button
              onClick={() => onTabChange('admin-review')}
              style={{
                backgroundColor: '#dc2626',
                color: 'white',
                border: 'none',
                padding: '16px',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              🔍 Admin Review
            </button>

            {/* Billing Dashboard Button */}
            <button
              onClick={() => onTabChange('billing-dashboard')}
              style={{
                backgroundColor: '#059669',
                color: 'white',
                border: 'none',
                padding: '16px',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              💰 Billing Dashboard
            </button>
      </div>

      {/* Recent Activity */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        {/* Recent Attendance */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb',
          padding: '20px'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '16px'
          }}>
            最近考勤紀錄
          </h3>
          {recentAttendance.length > 0 ? (
            <div>
              {recentAttendance.map((record, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 0',
                  borderBottom: index < recentAttendance.length - 1 ? '1px solid #e5e7eb' : 'none'
                }}>
                  <span style={{color: '#374151'}}>
                    {record.studentName || `學生${index + 1}`}
                  </span>
                  <span style={{
                    color: record.status === 'present' ? '#10b981' : '#ef4444',
                    fontWeight: '500'
                  }}>
                    {getAttendanceStatus ? getAttendanceStatus(record.status) : record.status}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p style={{color: '#6b7280', fontStyle: 'italic'}}>暫無考勤紀錄</p>
          )}
        </div>

        {/* Recent News */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb',
          padding: '20px'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '16px'
          }}>
            最新學校宣佈
          </h3>
          {recentNews.length > 0 ? (
            <div>
              {recentNews.map((news, index) => (
                <div key={index} style={{
                  padding: '8px 0',
                  borderBottom: index < recentNews.length - 1 ? '1px solid #e5e7eb' : 'none'
                }}>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#1f2937',
                    marginBottom: '4px'
                  }}>
                    {news.title || `公告${index + 1}`}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#6b7280'
                  }}>
                    {formatDate ? formatDate(news.date) : news.date}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{color: '#6b7280', fontStyle: 'italic'}}>暫無最新公告</p>
          )}
        </div>
      </div>

      {/* Upcoming Events */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e5e7eb',
        padding: '20px'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '16px'
        }}>
          即將舉行的活動
        </h3>
        {upcomingEvents.length > 0 ? (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '16px'
          }}>
            {upcomingEvents.map((event, index) => (
              <div key={index} style={{
                padding: '16px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px',
                border: '1px solid #e5e7eb'
              }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#1f2937',
                  marginBottom: '8px'
                }}>
                  {event.title || `活動${index + 1}`}
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  marginBottom: '4px'
                }}>
                  {formatDate ? formatDate(event.date) : event.date}
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#374151'
                }}>
                  {event.description || '活動描述'}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={{color: '#6b7280', fontStyle: 'italic'}}>暫無即將舉行的活動</p>
        )}
      </div>
    </div>
  );
};

export default MainPage;
